import { render, staticRenderFns } from "./definition-scoring.vue?vue&type=template&id=09fb7616&"
import script from "./definition-scoring.vue?vue&type=script&lang=js&"
export * from "./definition-scoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports